export type UpsellYouMightLikeItem = {
  name?: string;
  id?: string | number;
  redirect_to_category?: boolean | number;
  redirect_to_item?: boolean | number;
  redirected_item_id?: string | number;
  redirected_category_id?: string | number;
  category_name?: string;
};

export const isUpsellCategoryRedirect = (
  upSellItem: UpsellYouMightLikeItem | null | undefined
): boolean => upSellItem?.redirect_to_category === 1
  || upSellItem?.redirect_to_category === true;

export const buildUpsellClickArgs = (
  upSellItem: UpsellYouMightLikeItem | null | undefined,
  page_path?: string
): {
  label: string;
  page_path?: string;
  additional_params: Record<string, string | number>;
} | null => {
  const itemName = upSellItem?.name?.trim();
  if (!itemName) return null;

  if (isUpsellCategoryRedirect(upSellItem)) {
    const categoryId = upSellItem?.redirected_category_id;
    const categoryName = upSellItem?.category_name?.trim();
    if (categoryId == null || categoryId === '' || !categoryName) return null;

    return {
      label: itemName,
      page_path,
      additional_params: {
        category_id: categoryId,
        category_name: categoryName,
      },
    };
  }

  const itemId = upSellItem?.redirect_to_item
    ? upSellItem.redirected_item_id
    : (upSellItem?.redirected_item_id ?? upSellItem?.id);

  if (itemId == null || itemId === '') return null;

  return {
    label: itemName,
    page_path,
    additional_params: {
      item_id: itemId,
      item_name: itemName,
    },
  };
};
